
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import HinaRadioGroup from "@/views/ai-builder-component/baseComponent/hina-radio-group.vue";
import HinaCheckboxGroup from "@/views/ai-builder-component/baseComponent/hina-checkbox-group.vue";
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import HinaSelect from "@/views/ai-builder-component/baseComponent/hina-select.vue";
import HinaInput from "@/views/ai-builder-component/baseComponent/hina-input.vue";
import {
  AskConfig,
  QuestionItem,
  ReplyFixedSpeechList,
  RuleAsk,
  RandomConfig
} from "@/lib/model/exambuilder/exam-component/question";
import HinaTextarea from "@/views/ai-builder-component/baseComponent/hina-textarea.vue";
import HinaInputNumber from "@/views/ai-builder-component/baseComponent/hina-input-number.vue";
import HinaEmpty from "@/views/ai-builder-component/baseComponent/hina-empty.vue";
import { AigcAskType } from "@/lib/model/exambuilder/exam-component/company";
import EllipShow from "@/components/ellipShow.vue";
import { EnumQuestionType } from "@/lib/model/exambuilder/question-v2";

@Component({
  components: {
    EllipShow,
    HinaEmpty,
    HinaInputNumber,
    HinaTextarea,
    HinaInput,
    HinaSelect,
    HinaSwitch,
    HinaCheckboxGroup,
    HinaRadioGroup,
    Pop,
    InputNumberV3,
    IntroduceCard
  }
})
export default class AiAsk extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据
  @Prop({ default: "" }) builder!: string; // 创建面试来源

  mounted() {
    this.getAigcTypeOptions();
    const selectedList = this.askQuestionList.filter(
      item => item.appendAskConfig.enableAppendAsk === 1
    );
    this.formItemData.aiAsk.use = selectedList.length ? 1 : 2;
    this.appendScorePercent =
      selectedList[0]?.appendAskConfig?.appendScorePercent ?? 1;
    this.handleScorePercentChange();
  }

  // 是否是抽题组
  get isRandom() {
    return this.formItemData.questions.isRandomQuestion === 1;
  }

  appendScorePercent = 1;

  @Watch("appendScorePercent")
  handleScorePercentChange() {
    this.askQuestionList.forEach(item => {
      item.appendAskConfig.appendScorePercent = this.appendScorePercent;
    });
    this.$emit("setScorePercent", this.appendScorePercent);
  }

  setGlobal() {
    this.$emit("setGlobal");
  }

  trialOne() {
    this.$emit("trial", "aiAsk");
  }

  get askQuestionList() {
    if (this.isRandom) {
      return this.getRandomAskQuestionConfigList();
    } else {
      return this.formItemData.questions.questionConfigList.filter(item => {
        return this.isAppendAsk(item.questionId);
      });
    }
  }

  get canOpenDeepChat() {
    return true;
  }

  // 抽题组件的追问配置。因为即使是抽题组件，也是将追问配置配到题目上的，因此要从题目中拿到追问配置，然后再把追问配置
  getRandomAskQuestionConfigList() {
    const randomQuestionConfig: QuestionItem[] = [];
    this.formItemData.questions.randomConfigList.forEach(
      (item: RandomConfig) => {
        if (item.questionIdList.length > 0) {
          const temp:
            | QuestionItem
            | undefined = this.formItemData.questions.questionConfigList
            .filter(item => {
              return this.isAppendAsk(item.questionId);
            })
            .find(question => question.questionId === item.questionIdList[0]);
          if (temp) {
            randomQuestionConfig.push({
              ...temp,
              disabled: temp.answerTime > 0,
              randomTempConfig: item
            } as any);
          }
        }
      }
    );
    console.log(
      "🚀 ~ AiAsk ~ getRandomAskQuestionConfigList ~ randomQuestionConfig:",
      randomQuestionConfig
    );
    return randomQuestionConfig;
  }

  // 是否支持追问功能
  isAppendAsk(questionId: number): boolean {
    const question = this.formItemData.questionSelectedList.find(
      q => q.questionId === questionId
    );
    return question?.isVideoQuestion() || false;
  }

  // 如果配置了答题时间，则不允许配置追问 answerTime
  isConfigAnswerTime(questionItem: QuestionItem) {
    if (questionItem.answerTime <= 0) {
      return true;
    }
    return false;
  }

  // 抽题组题干
  getRandomText(questionGroup: QuestionItem, index: number) {
    if (
      !questionGroup.randomTempConfig ||
      !questionGroup.randomTempConfig.questionIdList
    )
      return "";
    return `组${index + 1}：${
      questionGroup.randomTempConfig.questionIdList.length > 0
        ? questionGroup.randomTempConfig.name || "抽题组卷题"
        : "抽题组卷题"
    } | ${questionGroup.randomTempConfig.questionIdList.length}抽${
      questionGroup.randomTempConfig.questionNumber
    } | ${
      questionGroup.randomTempConfig.questionIdList.length > 0
        ? this.getQuestionTypeText(
            questionGroup.randomTempConfig.questionType
          ) || "未选择题型"
        : "未选择题型"
    }`;
  }

  getQuestionTypeText(questionType: number) {
    switch (questionType) {
      case EnumQuestionType.EnumQuestionTypeVideo:
      case EnumQuestionType.EnumQuestionTypeVideoBody:
        return "视频题";
      case EnumQuestionType.EnumQuestionTypeNewSingleChoice:
      case EnumQuestionType.EnumQuestionTypeSingleChoice:
        return "选择题";
      case EnumQuestionType.EnumQuestionTypeBlanks:
        return "填空题";
      case EnumQuestionType.EnumQuestionTypeMP3:
        return "音频题";
    }
  }

  // 固定组题干
  getQuestionText(questionId: number, index: number) {
    const question = this.formItemData.questionSelectedList.find(
      q => q.questionId === questionId
    );

    return question ? `${index + 1}. ${question.descTextOnly}` : "";
  }

  // 追问开关
  handleChangeAsk(val: number, item: QuestionItem, index: number) {
    if (val === 1) {
      this.showRules(index, false);
    } else {
      item.appendAskConfig.ruleList = [];
    }
  }

  // 弹窗
  rulesDialog = false;
  activeIndex = -1;

  get activeQuestion() {
    return this.askQuestionList[this.activeIndex] || new QuestionItem();
  }

  showRules(index: number, showDialog = true) {
    this.activeIndex = index;

    if (!this.activeQuestion.appendAskConfig.ruleList.length) {
      this.activeQuestion.appendAskConfig.ruleList.push(new RuleAsk());
    }

    this.rulesDialog = showDialog;
  }

  cancelRule() {
    this.activeIndex = -1;
    this.rulesDialog = false;
  }

  submitRule() {
    this.activeQuestion.appendAskConfig.ruleList.forEach(rItem => {
      rItem.replyFixedSpeechList.forEach((item, index) => {
        item.roundNumber = index + 1;
      });
    });

    this.activeQuestion.appendAskConfig.enableAppendAsk = 1;
    this.activeIndex = -1;
    this.rulesDialog = false;
  }

  // 追问条件
  conditionTypeOptions = [
    { name: "固定100%触发", value: 1 },
    { name: "按回答字数触发", value: 2 }
  ];

  handleChangeConditionType(rule: RuleAsk) {
    if (rule.conditionType === 1) {
      rule.type = 1;
    }
  }

  // 话术类型
  typeOptions = [
    { name: "固定话术", value: 1 },
    { name: "AIGC话术", value: 2 }
  ];

  getTypeOptions(conditionType: number) {
    if (conditionType === 1) {
      return [this.typeOptions[0]];
    }

    return this.typeOptions;
  }

  // aigc模型
  aigcTypeOptions = [];
  async getAigcTypeOptions() {
    try {
      const list = await AigcAskType.getList();
      this.aigcTypeOptions = list.map((v: any) => {
        return {
          name: v.name,
          value: v.aigcAskType
        };
      });
    } catch (e) {
      console.log("🚀 ~ AiAsk ~ getAigcTypeDict ~ e:", e);
    }
  }

  // 添加追问demo
  async getAskDemo(ruleIndex: number, askIndex: number) {
    const roundItem = this.activeQuestion.appendAskConfig.ruleList[ruleIndex]
      .replyFixedSpeechList[askIndex];
    roundItem.loading = true;

    try {
      const question = this.formItemData.questionSelectedList.find(
        item => item.questionId === this.activeQuestion.questionId
      );

      if (!question) {
        throw "找不到题目";
      }

      const res = await AskConfig.getDemo(question.descTextOnly);

      roundItem.replyTextList = roundItem.replyTextList
        .concat(res)
        .filter(item => !!item);
    } catch (err) {
      this.$message.warning("获取追问demo失败");
    }

    roundItem.loading = false;
  }

  // 新增轮次
  addRoundAsk(ruleIndex: number) {
    this.activeQuestion.appendAskConfig.ruleList[
      ruleIndex
    ].replyFixedSpeechList.push(new ReplyFixedSpeechList());
  }

  delRoundAsk(ruleIndex: number, askIndex: number) {
    this.activeQuestion.appendAskConfig.ruleList[
      ruleIndex
    ].replyFixedSpeechList.splice(askIndex, 1);
  }

  // 规则操作
  moveAsk(direction: number, i: number) {
    const list1 = { ...this.activeQuestion.appendAskConfig.ruleList[i] };
    const list2 = {
      ...this.activeQuestion.appendAskConfig.ruleList[i + direction]
    };

    Object.assign(this.activeQuestion.appendAskConfig.ruleList[i], list2);
    Object.assign(
      this.activeQuestion.appendAskConfig.ruleList[i + direction],
      list1
    );
    this.$forceUpdate();
  }

  // 删除追问规则
  deleteRule(index: number) {
    this.activeQuestion.appendAskConfig.ruleList.splice(index, 1);
  }

  addRule() {
    this.activeQuestion.appendAskConfig.ruleList.push(new RuleAsk());
  }

  // 获取最终组合完成的 questions，
  // 固定题目，不做处理
  // 抽题组件，需要转换
  setFinalQuestions() {
    if (this.isRandom) {
      const tempList = JSON.parse(JSON.stringify(this.askQuestionList));
      for (let i = 0; i < tempList.length; i++) {
        const item = tempList[i];
        const idList = item.randomTempConfig.questionIdList;
        for (
          let i = 0;
          i < this.formItemData.questions.questionConfigList.length;
          i++
        ) {
          if (
            idList.includes(
              this.formItemData.questions.questionConfigList[i].questionId
            )
          ) {
            this.formItemData.questions.questionConfigList[i].appendAskConfig =
              item.appendAskConfig;
          }
        }
      }
    }
  }

  // 校验数据
  formItemCheck() {
    this.setFinalQuestions();
    return new Promise((resolve, reject) => {
      const valid = true;
      if (valid) {
        resolve("");
      } else {
        resolve("AiAnswer");
      }
    });
  }
}
